import type { Maybe } from '@/frontend-types'
import type { Config } from '@/payload-types'
import type { CollectionSlug, GlobalSlug } from 'payload'

export type AnyCollection = Config['collections'][CollectionSlug]
export type AnyGlobal = Config['globals'][GlobalSlug]
export type AnyDocument = AnyCollection | AnyGlobal

export function getDocId<T extends AnyCollection>(doc: T | T['id']) {
	return typeof doc === 'string' ? doc : doc.id
}

export function populated<T extends AnyDocument>(doc: Maybe<T | T['id']>): doc is T {
	return doc !== null && doc !== undefined && typeof doc !== 'string'
}
